import { useTranslation } from 'react-i18next';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import SvgGfmLogo from '../../svgs/logos/GfmLogo';
import { StyledBylineContainer, StyledPoweredBy } from './StartFundraiserButton.styled';
import { LinkButton } from '../LinkButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * StartFundraiserButton is a GoFundMe branded button.
 *
 * This block is a wrapper around `LinkButton`.
 */
export const StartFundraiserButton = ({
  href = '',
  openLinkInNewTab = false,
  parentLayoutInfo,
  ...rest
}) => {
  const {
    t
  } = useTranslation('blocks.startFundraiserButton');
  return /*#__PURE__*/_jsxs(StyledContentContainer, {
    parentLayoutInfo: parentLayoutInfo,
    children: [/*#__PURE__*/_jsx(LinkButton, {
      "data-id": "cp-link-button",
      alignXPreset: "left",
      cssBackgroundColor: "#1B1918",
      cssColor: "#ffffff",
      cssBorderRadius: "8px",
      href: href,
      content: "Start your fundraiser",
      target: openLinkInNewTab ? '_blank' : undefined,
      ...rest
    }), /*#__PURE__*/_jsxs(StyledBylineContainer, {
      children: [/*#__PURE__*/_jsx(StyledPoweredBy, {
        children: t('blocks.startFundraiserButton.poweredByLabel', 'Powered by')
      }), ' ', /*#__PURE__*/_jsx(SvgGfmLogo, {})]
    })]
  });
};